    <app-indicadores [dashBoardId]="5">
    </app-indicadores>